import Styled from "styled-components";
import { respondTo } from "../../../../respondTo";

export const CardMission = Styled.div`
    align-items: flex-start;;    
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 13.75rem;
    margin:0 0.625rem;
    ${respondTo.desktop`
       max-width: 16.47rem;
       
    `}
    ${respondTo.desktop_xl`
        min-width: 20.5rem;
        `}
    `;
export const CardMissionImage = Styled.div<{ selecteditem?: number }>`
    align-items: center;
    align-self: center;
    background-color: ${({ selecteditem }) => (selecteditem === 0 || selecteditem === 1 ? "#E2E2E5" : "var(--primary-container-dark)")};
    transition: background-color 0.5s ease-in-out;
    border-radius: 50%;
    display: flex;
    height: 5.625rem;
    width: 5.625rem;
    justify-content: center;
        img{
            width: 70%;
        } 
    ${respondTo.desktop`
        height: 8.375rem;
        width: 8.375rem;
        img{
            width: 60%;
        } 
    `}
 
`;
export const CustomeImg = Styled.div<{ selecteditem?: number }>`
    position: relative;
    width: 64px;
    height: 64px;
    max-width: 64px;
    max-height: 64px;
    ${({ selecteditem }) =>
      selecteditem === 0 || selecteditem === 1
        ? "filter:brightness(0) saturate(100%) invert(14%) sepia(42%) saturate(2148%) hue-rotate(174deg) brightness(100%) contrast(101%);"
        : ""};
    ${respondTo.desktop`
        width: 80px;
        height: 80px;
        max-width: 80px;
        max-height: 80px;
    `}

`;
export const CardMissionTitle = Styled.p<{ selecteditem?: number }>`
    color: ${({ selecteditem }) => (selecteditem === 2 || selecteditem === 3 ? "var(--on-primary-container-light)" : "var(--on-primary-container-dark)")}; 
    transition: color 0.5s ease-in-out;
    padding: 1.25rem 0 0.625rem 0;
    align-self: center;
   
    ${respondTo.desktop`
        padding: 2.5rem 0 0.625rem;
    `}

`;
export const CardMissionDescription = Styled.p<{ selecteditem?: number }>`
    color: ${({ selecteditem }) => (selecteditem === 2 || selecteditem === 3 ? "var(--on-primary-container-light)" : "var(--on-primary-container-dark)")};
    transition: color 0.5s ease-in-out;
    text-align: left;
`;
